import { rgb, luminance } from './utils'

export const background = (): string => {
  if (globalThis._CONFIGURATION_.colors === undefined) return '#fff'
  return globalThis._CONFIGURATION_.colors.background
}

export const watermark = (): string => {
  const multiplier = luminance(background()) < 0.4 ? 1 : -1

  return shade(background(), 40 * multiplier)
}

export const inactive = (): string => {
  if (globalThis._CONFIGURATION_.colors === undefined) return '#ccc'
  return globalThis._CONFIGURATION_.colors.inactive
}

export const defaultNode = (): string => {
  if (globalThis._CONFIGURATION_.colors === undefined) return '#000'
  return globalThis._CONFIGURATION_.colors.default.node
}

export const defaultLink = (): string => {
  if (globalThis._CONFIGURATION_.colors === undefined) return '#000'
  return globalThis._CONFIGURATION_.colors.default.link
}

const shade = (hex: string, amount: number): string => {
  let [r, g, b] = rgb(hex)

  r = Math.max(Math.min(255, r + amount), 0).toString(16)
  g = Math.max(Math.min(255, g + amount), 0).toString(16)
  b = Math.max(Math.min(255, b + amount), 0).toString(16)

  const rr = `${(r.length < 2 ? '0' : '')}${r}`
  const gg = `${(g.length < 2 ? '0' : '')}${g}`
  const bb = `${(b.length < 2 ? '0' : '')}${b}`

  return `#${rr}${gg}${bb}`
}
